export default __webpack_public_path__ + "static/media/Ies_panel_JuanLaso.332fab82.png";